import { Routes, Route, Link } from 'react-router';
import { Dashboard } from '@/routes/Dashboard';
import { Design } from '@/routes/Design';
import { PropertyDetail } from '@/routes/PropertyDetail';
import { JobsListPage } from '@/routes/JobsList';
import { JobDetailPage } from '@/routes/JobDetail';
import { SubmitPage } from '@/routes/Submit';
import { MapPage } from '@/routes/MapPage';
import { AdminPage } from '@/routes/AdminPage';
import { GlassPanel } from '@/components/glass/GlassPanel';

/**
 * Catch-all "Not yet built" page. Phases 05–09 ship /app/, /app/_design/,
 * /app/properties/:id, /app/jobs, /app/jobs/:id, /app/submit, /app/map,
 * and /app/admin. Phase 10 deletes the legacy EJS routes; until then
 * unknown paths fall through here.
 */
function NotFound() {
  return (
    <main
      id="main"
      className="min-h-screen bg-ocean-950 text-foam-50 flex items-center justify-center p-12"
    >
      <GlassPanel variant="strong" className="p-12 text-center max-w-md">
        <h1 className="text-3xl font-semibold mb-2">Not yet built</h1>
        <p className="text-foam-50/70">
          Phase 09+ delivers this route. Click{' '}
          <Link className="underline text-bronze-500 hover:text-bronze-500/90" to="/">
            here
          </Link>{' '}
          to return to the dashboard.
        </p>
      </GlassPanel>
    </main>
  );
}

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Dashboard />} />
      {/* The dashboard IS the properties grid. The GlobalNav "Properties" link
          (and any bookmarks) target /app/properties, so alias it to Dashboard
          — previously it fell through to the NotFound "Not yet built" page. */}
      <Route path="/properties" element={<Dashboard />} />
      <Route path="/_design" element={<Design />} />
      <Route path="/_design/" element={<Design />} />
      <Route path="/properties/:id" element={<PropertyDetail />} />
      {/* Phase 07 Plan 03 — jobs list, detail, and submit routes. EJS
          routes (/jobs, /submit) remain alive at the unprefixed paths
          until Phase 09 (MIGR-01) per Pitfall 5 (parity before decommission). */}
      <Route path="/jobs" element={<JobsListPage />} />
      <Route path="/jobs/:id" element={<JobDetailPage />} />
      <Route path="/submit" element={<SubmitPage />} />
      <Route path="/map" element={<MapPage />} />
      <Route path="/admin" element={<AdminPage />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
